import {AbstractEvent} from "@/modules/base/events";

export default class BeforeDatabasePreparedEvent extends AbstractEvent
{

}